import script from "./BlockBenefiting.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockBenefiting.vue?vue&type=script&setup=true&lang=js"

import "./BlockBenefiting.vue?vue&type=style&index=0&id=f6ed0b1a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6ed0b1a"]])

export default __exports__